// Shared by chart bar labels, chart axis ticks, and CSV export so a single value renders
// identically everywhere instead of drifting (integer as-is, otherwise fixed to 2 decimals —
// avoids float-summation tails like 1234.5000000000002 leaking into the CSV export).
export function formatStatisticNumber(value: number): string {
  return Number.isInteger(value) ? String(value) : value.toFixed(2);
}
